import styles from "./toolbox-uploads.module.css";
import { PhotoWithCoordinates } from "PosterEditor/model/poster-project";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";

import { GPSUploadSection } from "./gps/gps-upload-section";
import { UploadedPhotosGrid } from "./images-section/uploaded-photos-grid";
import { loadGPXFromURL } from "PosterEditor/utils/file-import";
import { useState } from "react";

interface ToolboxUploadsProps {}

export const ToolboxUploads = (props: ToolboxUploadsProps) => {
  const { createStyledPointFromPhoto, setCoordinates } = usePosterProject();
  const [GPXUploadFound, setGPXUploadFound] = useState(false);
  const applyPhotos = (photos: PhotoWithCoordinates[]) => {
    photos.forEach((photo) => {
      createStyledPointFromPhoto(photo).then((styledPoint) => {
        if (styledPoint) {
          // Here you would typically add the styled point to your project
          console.log("Styled point created:", styledPoint);
        } else {
          console.warn("Failed to create styled point from photo:", photo);
        }
      });
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.paddedBodyContent}>
        <GPSUploadSection
          onFoundGPX={(found) => setGPXUploadFound(found)}
          emptyTitle="GPS ROUTE"
          emptyDescription="Use the iOS app to upload an activity route (or make one out of photo
        locations), upload a GPX file here, or create a route out of your photo
        locations"
        />
      </div>
    </div>
  );
};
